import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { createExpression as e } from "../expression/expression.js";
import { BooleanType as r } from "../expression/types.js";

var t = /*#__PURE__*/function () {
  function t(e) {
    _classCallCheck(this, t);

    this._expression = e;
  }

  _createClass(t, [{
    key: "filter",
    value: function filter(e, r) {
      if (!this._expression) return !0;

      try {
        return this._expression.evaluate(e, r);
      } catch (_t) {
        return console.log(_t.message), !0;
      }
    }
  }], [{
    key: "createFilter",
    value: function createFilter(n) {
      if (!n) return null;
      this.isLegacyFilter(n) && (n = this.convertLegacyFilter(n));

      try {
        var s = e(n, null, r);
        return new t(s);
      } catch (s) {
        return console.log(s.message), null;
      }
    }
  }, {
    key: "isLegacyFilter",
    value: function isLegacyFilter(e) {
      if (!Array.isArray(e)) return !0;
      if (0 === e.length) return !0;

      switch (e[0]) {
        case "==":
        case "!=":
        case ">":
        case "<":
        case ">=":
        case "<=":
          return 3 === e.length && "string" == typeof e[1] && !Array.isArray(e[2]);

        case "in":
          return e.length >= 3 && "string" == typeof e[1] && !Array.isArray(e[2]);

        case "!in":
        case "none":
        case "!has":
          return !0;

        case "any":
        case "all":
          for (var _r = 1; _r < e.length; _r++) {
            if (!this.isLegacyFilter(e[1])) return !1;
          }

          return !0;

        case "has":
          return 2 === e.length && ("$id" === e[1] || "$type" === e[1]);

        default:
          return !1;
      }
    }
  }, {
    key: "convertLegacyFilter",
    value: function convertLegacyFilter(e) {
      if (!Array.isArray(e) || 0 === e.length) return !0;
      var r = e[0];
      if (1 === e.length) return "any" !== r;

      switch (r) {
        case "==":
          return t.convertComparison("==", e[1], e[2]);

        case "!=":
          return t.negate(t.convertComparison("==", e[1], e[2]));

        case ">":
        case "<":
        case ">=":
        case "<=":
          return t.convertComparison(r, e[1], e[2]);

        case "in":
          return t.convertIn(e[1], e.slice(2));

        case "!in":
          return t.negate(t.convertIn(e[1], e.slice(2)));

        case "any":
        case "all":
        case "none":
          return t.convertCombining(r, e.slice(1));

        case "has":
          return t.convertHas(e[1]);

        case "!has":
          return t.negate(t.convertHas(e[1]));

        default:
          throw new Error("Unexpected legacy filter.");
      }
    }
  }, {
    key: "convertComparison",
    value: function convertComparison(e, r, _t2) {
      switch (r) {
        case "$type":
          return [e, ["geometry-type"], _t2];

        case "$id":
          return [e, ["id"], _t2];

        default:
          return [e, ["get", r], _t2];
      }
    }
  }, {
    key: "convertIn",
    value: function convertIn(e, r) {
      switch (e) {
        case "$type":
          return ["in", ["geometry-type"], ["literal", r]];

        case "$id":
          return ["in", ["id"], ["literal", r]];

        default:
          return ["in", ["get", e], ["literal", r]];
      }
    }
  }, {
    key: "convertHas",
    value: function convertHas(e) {
      switch (e) {
        case "$type":
          return !0;

        case "$id":
          return ["has-id"];

        default:
          return ["has", e];
      }
    }
  }, {
    key: "convertCombining",
    value: function convertCombining(e, r) {
      return [e].concat(r.map(this.convertLegacyFilter));
    }
  }, {
    key: "negate",
    value: function negate(e) {
      return ["!", e];
    }
  }]);

  return t;
}();

export { t as default };